import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Intentaste aprender a usar todas las herramientas de IA nuevas, pero cada semana salen diez más y la ansiedad sólo aumenta.', 'Intentaste trabajar más horas para demostrar compromiso, pero la máquina no duerme y nunca le ganarás en volumen.', 'Intentaste ignorar el problema pensando que "en mi sector no llegará", mientras ves cómo los presupuestos y los equipos se reducen a tu alrededor.', 'Intentaste competir en velocidad, perdiendo la esencia de por qué elegiste esta profesión en primer lugar.'];
  return <section className="py-20 px-4 bg-dark-800 border-t border-gold-500/10" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-serif text-gold-500 mb-6 text-center" data-id="element-199">
            La Perfección es tu Peor Enemigo
          </h2>
          <div className="space-y-6 text-lg text-gray-300" data-id="element-200">
            <p data-id="element-201">
              Llevas años siendo el más rápido, el que más entrega, el que nunca
              falla. Pero esa misma perfección es la que te hace peligroso para
              ti mismo: has eliminado tanto el factor humano de tu trabajo que
              te has vuelto "transparente" para tu empresa.
            </p>
            <p data-id="element-202">
              Si tu valor se basa en procesar datos, redactar informes estándar
              o seguir manuales, estás en el corredor de la muerte profesional.
              La IA no viene a por tu empleo; viene a por tus tareas. Y si tus
              tareas son lo único que eres, tú desapareces con ellas.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-203">
          <h3 className="text-2xl font-serif text-white mb-8 text-center" data-id="element-204">
            Por qué lo que intentaste no funcionó
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-205">
            {failedAttempts.map((attempt, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-dark-900 p-6 rounded-lg border border-red-900/30 flex items-start space-x-4" data-id="element-206">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-207" />
                <p className="text-gray-400" data-id="element-208">{attempt}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}